export function OutlineCampanasUrbanosIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.74263 17.9993C7.39223 17.3993 6.75383 16.9961 6.01464 16.9961C5.27544 16.9961 4.63224 17.3993 4.28184 17.9993H3.01465V10.9961C3.01465 10.9961 19.3442 10.9961 21.0146 10.9961"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.01637 18.9987C8.01637 20.0979 7.11877 21.0003 6.01478 21.0003C4.91078 21.0003 4.01318 20.0979 4.01318 18.9987C4.01318 18.6387 4.11398 18.2883 4.28198 18.0003C4.63238 17.4004 5.27078 17.002 6.00998 17.002C6.74917 17.002 7.39237 17.4004 7.73797 18.0003C7.90597 18.2883 8.00677 18.6387 8.00677 18.9987H8.01637Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M3.01465 11.0016V5.00639C3.01465 3.8976 3.91224 3 5.02104 3H21.0194V15.9983"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0146 3V11.0016"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.01465 3V11.0016"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.01465 14.002H4.95384"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.6886 20.0538L17.943 20.0442L15.7062 20.0346L11.2183 20.0154L13.1335 14.3418L20.6886 20.0538Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4547 13.3965L10.9011 20.9613"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.01 19.1074L20.3716 20.9986"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
